/* eslint-disable */
import React, { useEffect, useState, useMemo, useRef } from "react";

import { Link, useParams, useHistory } from "react-router-dom";
import Select from "react-select";

import { useTranslation } from "react-i18next";

// import { Editor } from "@tinymce/tinymce-react";
import JoditEditor from "jodit-react";

//image resize for editor
// import { resizeOrCompressImage } from "helper/Common/CommonHelper";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import {
  postData,
  getData,
  putData,
  uploadSingleFile,
  uploadMultipleFile,
} from "utils/Gateway";

// import fileDownloadHandler from "helper/DownloadFile";
import TaskStatusOptions from "data/Prod/TaskStatus.json";
import TaskPriority from "data/Prod/TaskPriority.json";
// import { assetImages } from "constants";
import downloadFileHandler from "helper/DownloadFile";
// import { joditEditorConfig } from "Config/Config";
// import { getDateFormatInSpanish } from "helper/Common/CommonHelper";
import TaskModules from "data/Prod/TaskModuleListOptions.json";
import { reactSelectStyle } from "Config/Config";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";

const SaveTaskTab = ({
  moduleName = "",
  selectedModuleSlug = "",
  contactId,
  leadId,
  projectId,
  sectionId,
  closePopup,
  sectionOptions = [],
  projectValue = null,
  leadValue = null,
  selectedSectionValue = null,
  contactValue = null,
  selectedTaskId,
  isReset,
  setIsReset,
  getTaskList,
  selectedTags = [],
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
}) => {
  const todayValue = new Date().toISOString().split("T")[0];
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const userObj = {
    label: `${userInfo.name ?? userInfo.email} ${userInfo.surname ?? ""}`,
    value: userInfo._id,
  };

  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  const params = useParams();
  const token = localStorage.getItem("token");

  const loadingCircle = [1, 2, 3, 4, 5, 6]; //for upload doc

  const docFileInputRef = useRef(null);

  const [assignedUserInput, setAssignedUserInput] = useState("");
  const [assignedUserOptions, setAssignedUserOptions] = useState([userObj]);

  const [followersInput, setFollowersInput] = useState("");
  const [followersOptions, setFollowersOptions] = useState([userObj]);

  const [previousTaskInput, setPreviousTaskInput] = useState("");
  const [previousTaskIdaskListOptions, setpreviousTaskListOptions] = useState(
    []
  );
  const [projectInput, setprojectInput] = useState("");
  const [projectListOptions, setprojectListOptions] = useState([]);
  const [sectionInput, setsectionInput] = useState("");
  const [sectionListOptions, setsectionListOptions] = useState(sectionOptions);
  const [leadInput, setleadInput] = useState("");
  const [leadListOptions, setleadListOptions] = useState([]);
  const [contactInput, setcontactInput] = useState("");
  const [contactOptions, setcontactOptions] = useState([]);
  const [taskProjectId, settaskProjectId] = useState(projectId);
  const [taskLeadId, settaskLeadId] = useState(leadId);
  const [taskContactId, settaskContactId] = useState(contactId);
  const [taskCustomId, setTaskCustomId] = useState(null);
  const [title, settitle] = useState("");
  const [details, setdetails] = useState("");
  const [moduleValue, setmoduleValue] = useState(null);
  const [moduleSlug, setmoduleSlug] = useState(selectedModuleSlug);
  const [selectedProjectValue, setSelectedProjectValue] =
    useState(projectValue);
  const [sectionValue, setsectionValue] = useState(selectedSectionValue);
  const [selectedSectionId, setselectedSectionId] = useState(sectionId);
  const [selectedLeadValue, setselectedLeadValue] = useState(leadValue);
  const [selectedContactValue, setselectedContactValue] = useState(null);
  const [taskStatusValue, settaskStatusValue] = useState(null);
  const [taskStatus, settaskStatus] = useState("");
  const [prevTaskValue, setPrevTaskValue] = useState(null);
  const [previousTaskId, setPreviousTaskId] = useState(null);
  const [hours, sethours] = useState(1);
  const [price, setPrice] = useState("");
  const [startDate, setstartDate] = useState(todayValue);
  const [endDate, setendDate] = useState(todayValue);
  const [priorityValue, setpriorityValue] = useState(null);
  const [priority, setpriority] = useState("");
  const [assignedUserValue, setassignedUserValue] = useState(null);
  const [assignedUserId, setassignedUserId] = useState(null);
  const [followrsValue, setFollowrsValue] = useState(null);
  const [selectedFollowers, setSelectedFollowers] = useState([]);
  const [taskPercent, settaskPercent] = useState(0);
  const [rank, setRank] = useState(1);
  const [docFileUploading, setDocFileUploading] = useState(false);
  const [uploadedDocFiles, setUploadedDocFiles] = useState([]);
  const [uploadedDocFileIds, setUploadedDocFileIds] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");

  const [isMilestone, setIsMilestone] = useState(false);

  /* hooks for validation */
  const [errors, setErrors] = useState({});

  const editor = useRef(null);

  // const editorCustomConfig = joditEditorConfig();
  const editorCustomConfig = {
    readonly: false,
    placeholder: "",
    minHeight: 400,
    uploader: {
      insertImageAsBase64URI: false,
    },
    events: {
      afterPaste: async (event) => {
        // take the saved clipboard data
        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;

        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            const file = items[i].getAsFile();

            // Rename the file using a timestamp
            const timestamp = Date.now();
            const fileExtension = file.type.split("/")[1]; // Get the file extension (e.g., png, jpeg)
            const newFileName = `image-${timestamp}.${fileExtension}`;

            const renamedFile = new File([file], newFileName, {
              type: file.type,
            });

            try {
              // upload the file data in server
              const requestUrl =
                url.API_BASE_URL +
                url.API_SINGLE_FILE_UPLOAD +
                ``;

              const response = await uploadSingleFile(requestUrl, renamedFile);

              if (response.status) {
                const imageUrl = url.SERVER_URL + response.data.path;
                // console.log("imageUrl", imageUrl);

                // Replace blob URL with the server URL
                const editorInstance = editor.current;

                if (editorInstance) {
                  const content = editorInstance.value;
                  const regex = /<img[^>]+src="data:image\/[^">]+"/g;
                  const newContent = content.replace(regex, (match) => {
                    const base64DataMatch = match.match(/src="([^"]+)"/);
                    if (
                      base64DataMatch &&
                      base64DataMatch[1].startsWith("data:image/")
                    ) {
                      return match.replace(base64DataMatch[1], imageUrl);
                    }
                    return match;
                  });

                  // add in editor content
                  editorInstance.value = newContent;

                  // add in state content
                  setdetails(newContent);
                }
              }
            } catch (error) {
              console.error("Image upload failed:", error);
            }
          }
        }
      },
    },
    defaultActionOnPaste: "insert_as_html",
    defaultLineHeight: 1.5,
    enter: "div",
    statusbar: false,
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 400,
    toolbarAdaptive: false,
    disablePlugins: [
      "image",
      "video",
      "about",
      "classSpan",
      "file",
      "speechRecognize",
      "copyformat",
      "spellcheck",
      "link",
      "add-new-line",
    ],
  };

  const editorConfig = useMemo(() => editorCustomConfig, []);

  // validate =========================
  const validationHandler = () => {
    const newErrors = {};

    if (title.trim() === "") {
      newErrors.name = t("Please enter a name for the task.");
    }

    if (hours === "" || parseFloat(hours) <= 0) {
      newErrors.hours = t("Estimated hours must be a positive number.");
    }

    if (startDate === "") {
      newErrors.startDate = t("A start date is required for the task.");
    }

    if (endDate === "") {
      newErrors.endDate = t("An end date is required for the task.");
    }

    if (startDate !== "" && endDate !== "") {
      const start = new Date(startDate);
      const end = new Date(endDate);
      if (start.getTime() > end.getTime()) {
        newErrors.dateRange = t(
          "The end date cannot be earlier than the start date."
        );
      }
    }

    if (!taskStatus) {
      // Simplified check
      newErrors.status = t("Please select the current status of the task.");
    }

    if (!priority) {
      // Simplified check
      newErrors.priority = t("Please set a priority level for the task.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //get all tasks for select previous task
  const getAllPreviousTask = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_TASKLIST_BY_SEARCH +
        `?searchtitle=${previousTaskInput}`;

      if (projectId) {
        requestUrl += `&projectid=${projectId}`;
      }

      // console.log(requestUrl);

      const response = await getData(requestUrl);

      // console.log("response in task list------->", response);

      if (response.status) {
        setpreviousTaskListOptions(response.data);
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //get last saved task details
  const getLastSavedTaskDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_LAST_SAVED_TASK_DETAILS +
        ``;

      const response = await getData(requestUrl);

      console.log("response in last saved task----->", response);

      if (response.status) {
        if (response.data) {
          setIsMilestone(
            response.data.ismilestone ? response.data.ismilestone : false
          );

          // settaskPercent(response.data.taskpercent ?? 0);

          sethours(response.data.hours ?? 1);
          setPrice(response.data.price ?? 0);
          setRank(response.data.rank);

          TaskPriority.map((priorityData) => {
            if (priorityData.value === response.data.priority) {
              prioritySelectionHandler(priorityData);
            }
          });

          //assign uploaded files
          setUploadedDocFiles(
            response?.data?.uploadedfiles.map(
              ({ name, path, _id, ...other }) => ({
                name,
                path: url.SERVER_URL + path,
                _id,
              })
            )
          );

          setUploadedDocFileIds(response?.data?.uploadedfileids);

          if (response.data.projectdata) {
            settaskProjectId(response.data.projectdata?.value);
            projectSelectionHandler(response.data.projectdata);
          }

          if (response.data.sectiondata) {
            sectionSelectionHandler(response.data.sectiondata);
          }

          if (response.data.moduleslug) {
            for (let TaskModule of TaskModules) {
              if (TaskModule.value === response.data.moduleslug) {
                moduleSelectionHandler(TaskModule);
              }
            }
          }

          if (response.data.taskleadid) {
            settaskLeadId(response.data.taskleadid);
          }

          if (response.data.taskleadvalue) {
            leadSelectionHandler(response.data.taskleadvalue);
          }

          if (response.data.taskcontactid) {
            settaskContactId(response.data.taskcontactid);
          }

          if (response.data.taskcontactvalue) {
            contactSelectionHandler(response.data.taskcontactvalue);
          }
        }
      } else {
        setAlertMessage(response.message);
        setMessageType("error");
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //get all projects
  const getProjectList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_PROJECTLIST_BY_SEARCH +
        `?searchtitle=${projectInput}`;

      const response = await getData(requestUrl);

      // console.log(response);

      if (response.status) {
        setprojectListOptions(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //get section list
  const getSectionList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_SECTION_LIST_OPTIONS +
        `?projectid=${taskProjectId}&sectiontitle=${sectionInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setsectionListOptions(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //get lead list
  const getLeadList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_LEAD_OPTIONS +
        `?leadstringinput=${leadInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setleadListOptions(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //get contact list
  const getContactList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_CONTACTS_OPTIONS +
        `?userstring=${contactInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        const mappedData = response.data.map((item) => ({
          label: item.label,
          value: item._id,
        }));

        setcontactOptions(mappedData);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get assigned user list
  const getAssignedUserList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_FOR_TASK +
        `` +
        `&modulename=${moduleName}&userstring=${assignedUserInput}&projectid=${taskProjectId}&optiontype=assigneduser`;

      const response = await getData(requestUrl);

      // console.log(response);

      if (response.status) {
        if (response.data.length > 0) {
          setAssignedUserOptions([...response.data, userObj]);
        }
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //function for get followers list
  const getFollowersList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_FOR_TASK +
        `` +
        `&modulename=${moduleName}&userstring=${followersInput}&projectid=${taskProjectId}&optiontype=follower`;

      const response = await getData(requestUrl);

      if (response.status) {
        if (response.data.length > 0) {
          setFollowersOptions([...response.data, userObj]);
        }
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //function for select module
  const moduleSelectionHandler = (val) => {
    if (val) {
      setmoduleValue(val);
      setmoduleSlug(val.value);

      if (val.value !== "MOD_PROJECT") {
        projectSelectionHandler(null);
        sectionSelectionHandler(null);
      }
    } else {
      setmoduleValue(null);
      setmoduleSlug("");
      projectSelectionHandler(null);
      sectionSelectionHandler(null);
    }
  };

  //function for select project
  const projectSelectionHandler = (val) => {
    if (val) {
      setSelectedProjectValue(val);
      settaskProjectId(val.value);
      setsectionValue(null);
      setselectedSectionId(null);
    } else {
      setSelectedProjectValue(null);
      settaskProjectId(null);
      setsectionValue(null);
      setselectedSectionId(null);
    }
  };

  //select section
  const sectionSelectionHandler = (val) => {
    if (val) {
      setsectionValue(val);
      setselectedSectionId(val.value);
    } else {
      setsectionValue(null);
      setselectedSectionId(null);
    }
  };

  //select lead
  const leadSelectionHandler = (val) => {
    if (val) {
      setselectedLeadValue(val);
      settaskLeadId(val.value);
    } else {
      setselectedLeadValue(null);
      settaskLeadId(null);
    }
  };

  //select contact
  const contactSelectionHandler = (val) => {
    if (val) {
      setselectedContactValue(val);
      settaskContactId(val.value);
    } else {
      setselectedContactValue(null);
      settaskContactId(null);
    }
  };

  //select status
  const statusSelectionHandler = (val) => {
    settaskStatusValue(val);
    if (
      val.value === "0" ||
      val.value === "1" ||
      val.value === "2" ||
      val.value === "3"
    ) {
      settaskStatus(val.value);
    }
  };

  //select priority
  const prioritySelectionHandler = (val) => {
    setpriorityValue(val);
    setpriority(val.value);
  };

  //function for get user input
  const assignedUserInputHandler = (val) => {
    setAssignedUserInput(val);
    seterrorMessage("");
  };

  //function for get followers input
  const followersInputHandler = (val) => {
    setFollowersInput(val);
    seterrorMessage("");
  };

  //select assigned user
  const assignedUserSelectionHandler = (val) => {
    if (val) {
      setassignedUserValue(val);
      setassignedUserId(val.value);
    } else {
      setassignedUserValue(null);
      setassignedUserId(null);
    }
  };

  //select followers
  const followersSelectionHandler = (val) => {
    setFollowrsValue(val);
    setSelectedFollowers(val.map((item) => item.value));
  };

  //select previous task
  const previousTaskSelectionHandler = (val) => {
    if (val) {
      setPrevTaskValue(val);
      setPreviousTaskId(val.value);
      setstartDate(val.enddate);
      setendDate("");
    } else {
      setPrevTaskValue(null);
      setPreviousTaskId(null);
      setpreviousTaskListOptions([]);
      // setstartDate("");
      // setendDate("");
    }
  };

  //function for open doc imput
  const openDocFileInput = () => {
    docFileInputRef.current.click();
  };

  //function for upload doc files
  const docFileUploadHandler = async (docFiles) => {
    try {
      setDocFileUploading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD;

      const response = await uploadMultipleFile(requestUrl, docFiles);

      if (response.status) {
        /*----- assign uploaded files with path for display start ------*/
        const uploadedFileValues = response.data.map(
          ({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          })
        );

        //check old file exist or not if exist then new file will concat with old file
        if (uploadedDocFiles.length == 0) {
          setUploadedDocFiles(uploadedFileValues);
        } else {
          let fileArr = uploadedDocFiles.concat(uploadedFileValues);
          setUploadedDocFiles(fileArr);
        }

        /*----- assign uploaded files with path for display end ------*/
        setDocFileUploading(false);

        /*----- assign uploaded file ids start ------*/
        const fileIds = response.data.map(({ _id, ...other }) => ({ _id }));

        //check old file ids are exist or not.If exist then new id will concat with old id
        if (uploadedDocFileIds.length == 0) {
          setUploadedDocFileIds(fileIds);
        } else {
          let fileArr = uploadedDocFileIds.concat(fileIds);
          setUploadedDocFileIds(fileArr);
        }
        /*----- assign uploaded file ids end ------*/
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
      resetDocInput();
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //function for delete file from upload stack
  const closeDocFileHandler = (index) => {
    const closedFile = [...uploadedDocFiles];
    const removedFileId = [...uploadedDocFileIds];
    closedFile.splice(index, 1);
    removedFileId.splice(index, 1);
    setUploadedDocFiles(closedFile);
    setUploadedDocFileIds(removedFileId);
    resetDocInput();
  };

  //function for reset doc inputs
  const resetDocInput = () => {
    const file = document.getElementById("uploadedTaskDoc");
    if (file) {
      file.value = null;
    } else {
      return;
    }
  };

  //get task details
  const getTaskDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_TASK_DETAILS +
        `/${selectedTaskId}`;

      // console.log(requestUrl);

      const response = await getData(requestUrl);

      console.log("task details", response);

      if (response.status) {
        assignedUserSelectionHandler(response.data.assigneduserdata);
        followersSelectionHandler(response.data.followersarr);
        setTaskCustomId(response.data.customid);
        settitle(response.data.title);
        setIsMilestone(
          response.data.ismilestone ? response.data.ismilestone : false
        );
        setdetails(response.data.description);
        settaskPercent(response.data.taskpercent ?? 0);

        if (response.data.completedpercent) {
          const selectedStatus = TaskStatusOptions.find(
            (statusData) => statusData.value == response.data.completedpercent
          );

          statusSelectionHandler(
            selectedStatus ? selectedStatus : TaskStatusOptions[0]
          );
        }

        sethours(response.data.hours ?? 0);
        setPrice(response.data.price ?? 0);
        setstartDate(response.data.startdate);
        setendDate(response.data.enddate);
        setRank(response.data.rank);

        TaskPriority.map((priorityData) => {
          if (priorityData.value === response.data.priority) {
            prioritySelectionHandler(priorityData);
          }
        });

        //assign uploaded files
        setUploadedDocFiles(
          response?.data?.uploadedfiles.map(
            ({ name, path, _id, ...other }) => ({
              name,
              path: url.SERVER_URL + path,
              _id,
            })
          )
        );

        setUploadedDocFileIds(response?.data?.uploadedfileids);

        if (response.data.projectdata) {
          settaskProjectId(response.data.projectdata?.value);
          projectSelectionHandler(response.data.projectdata);
        }

        if (response.data.sectiondata) {
          const sectionValue = response.data.sectiondata;
          setsectionValue(sectionValue);
          setselectedSectionId(sectionValue.value);
        }

        if (response.data.moduleslug) {
          for (let TaskModule of TaskModules) {
            if (TaskModule.value === response.data.moduleslug) {
              moduleSelectionHandler(TaskModule);
            }
          }
        }

        if (response.data.taskleadid) {
          settaskLeadId(response.data.taskleadid);
        }

        if (response.data.taskleadvalue) {
          leadSelectionHandler(response.data.taskleadvalue);
        }

        if (response.data.taskcontactid) {
          settaskContactId(response.data.taskcontactid);
        }

        if (response.data.taskcontactvalue) {
          contactSelectionHandler(response.data.taskcontactvalue);
        }

        if (response.data.previoustaskvalue) {
          // previousTaskSelectionHandler(response.data.previoustaskvalue);
          setPrevTaskValue(response.data.previoustaskvalue);
          setPreviousTaskId(response.data.previoustaskvalue.value);
        }
      } else {
        seterrorMessage(response.message);
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //save task
  const saveTaskHandler = async () => {
    if (validationHandler()) {
      seterrorMessage("");

      try {
        setIsSaving(true);

        let taskData = {
          moduleslug: moduleSlug,
          leadid: null,
          project: null,
          contact: null,
          projectsection: null,
          previoustask: previousTaskId,
          title,
          description: details,
          ismilestone: isMilestone,
          startdate: startDate,
          enddate: endDate,
          hours,
          price,
          priority,
          completedpercent: taskStatus,
          taskpercent: taskPercent,
          assigneduser: assignedUserId,
          followers: selectedFollowers,
          rank: rank || 1,
          uploads: uploadedDocFileIds,
        };

        if (taskLeadId) {
          taskData.leadid = taskLeadId;
        }

        if (taskContactId) {
          taskData.contact = taskContactId;
        }

        if (taskProjectId) {
          taskData.project = taskProjectId;
        }

        if (selectedSectionId) {
          taskData.projectsection = selectedSectionId;
        }

        // console.log(taskData);

        let response = {};

        if (selectedTaskId) {
          let requestUrl =
            url.API_BASE_URL +
            url.API_UPDATE_PROJECT_TASK +
            `/${selectedTaskId}`;

          response = await putData(requestUrl, taskData);
        } else {
          taskData.tags = selectedTags;
          let requestUrl =
            url.API_BASE_URL + url.API_ADD_NEW_PROJECT_TASK;

          response = await postData(requestUrl, taskData);
        }

        setIsSaving(false);

        console.log(response);

        if (response.status) {
          setMessageType("success");
          closePopup();
          let offCanvasPopup = document.querySelector("#addTask_view");
          let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
          offCanvas.hide();
          getTaskList(response.data);
        } else {
          setMessageType("error");
          seterrorMessage(response.message);
        }
        setAlertMessage(response.message);
      } catch (error) {
        setMessageType("error");
        setAlertMessage(error.message);
      }
    } else {
      seterrorMessage(t("Please fill up all required fields"));
      setAlertMessage(t("Please fill up all required fields"));
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for default set values
  const defaultValueAssignHandler = () => {
    if (moduleName !== "" && moduleSlug !== "") {
      // console.log("moduleName", moduleName, "moduleSlug", moduleSlug);

      const loggedInUserOption = [
        {
          label: `${userInfo.name ?? userInfo.email} ${userInfo.surname ?? ""}`,
          value: userInfo._id,
        },
      ];

      const loggedInUserValue = {
        label: `${userInfo.name ?? userInfo.email} ${userInfo.surname ?? ""}`,
        value: userInfo._id,
      };

      const loggedInUserIdArray = [userInfo._id];

      for (let TaskModule of TaskModules) {
        if (TaskModule.value === moduleSlug) {
          moduleSelectionHandler(TaskModule);
        }
      }

      if (moduleSlug == "MOD_LEAD" || moduleSlug == "MOD_CONTACT") {
        //assign logged in user as assigned user and follower
        setAssignedUserOptions(loggedInUserOption);
        setFollowersOptions(loggedInUserOption);
        setassignedUserValue(loggedInUserValue);
        setFollowrsValue(loggedInUserValue);
        setassignedUserId(userInfo._id);
        setSelectedFollowers(loggedInUserIdArray);

        //assing lead value or contact value
        if (moduleSlug == "MOD_LEAD" && leadValue) {
          leadSelectionHandler(leadValue);
        }

        if (moduleSlug == "MOD_CONTACT" && contactValue) {
          contactSelectionHandler(contactValue);
        }
      }

      if (moduleSlug === "MOD_PROJECT") {
        // setAssignedUserOptions([]);
        // setFollowersOptions([]);
        // setassignedUserValue(null);
        // setFollowrsValue(null);
        // setassignedUserId(null);
        // setSelectedFollowers([]);

        // if (!taskProjectId && projectValue) {
        //   projectSelectionHandler(projectValue);
        // }

        if (!selectedSectionId && selectedSectionValue) {
          sectionSelectionHandler(selectedSectionValue);
        }

        if (projectValue) {
          projectSelectionHandler(projectValue);
          setprojectListOptions([projectValue]);
        }
      }
    }
  };

  // Reset all the form fields and state variables to their initial values
  const resetHandler = () => {
    // If there is no selected task ID, set the assigned user ID and value to null
    if (!selectedTaskId) {
      setAssignedUserInput("");
      setAssignedUserOptions([userObj]);
      setassignedUserId(null);
      setassignedUserValue(null);
      setFollowersInput("");
      setFollowersOptions([userObj]);
      setFollowrsValue(null);
      setSelectedFollowers([]);
    }

    settitle("");
    setTaskCustomId(null);
    setdetails("");
    setIsMilestone(false);
    setselectedLeadValue(null);

    setselectedContactValue(null);

    setSelectedProjectValue(null);
    settaskProjectId(null);
    setsectionValue(null);
    setselectedSectionId(null);
    setPrevTaskValue(null);
    setPreviousTaskId(null);
    setpreviousTaskListOptions([]);
    sethours(1);
    setPrice("");
    setstartDate(todayValue);
    setendDate(todayValue);
    setRank(1);
    setUploadedDocFileIds([]);
    setUploadedDocFiles([]);
    TaskStatusOptions.map((statusData) => {
      if (statusData.value == "0") {
        statusSelectionHandler(statusData);
      }
    });
    TaskPriority.map((priorityData) => {
      if (priorityData.value === "2") {
        prioritySelectionHandler(priorityData);
      }
    });
    setErrors({});
    seterrorMessage("");

    // defaultValueAssignHandler();

    if (moduleName === "mytask") {
      setmoduleValue(null);
      setmoduleSlug("");
      settaskLeadId(null);
      settaskContactId(null);

      const loggedInUserValue = {
        label: `${userInfo.name ?? userInfo.email} ${userInfo.surname ?? ""}`,
        value: userInfo._id,
      };

      setassignedUserValue(loggedInUserValue);
      setassignedUserId(userInfo._id);

      getLastSavedTaskDetails();
    } else {
    }
  };

  useEffect(() => {
    if (selectedTaskId) {
      getTaskDetails();
    }
  }, [selectedTaskId]);

  useEffect(() => {
    if (isReset) {
      resetHandler();
      setIsReset(false);
    }
  }, [isReset]);

  useEffect(() => {
    TaskStatusOptions.map((statusData) => {
      if (statusData.value == "0") {
        statusSelectionHandler(statusData);
      }
    });

    TaskPriority.map((priorityData) => {
      if (priorityData.value === "2") {
        prioritySelectionHandler(priorityData);
      }
    });

    setstartDate(todayValue);
    setendDate(todayValue);

    if (moduleName === "mytask") {
      const loggedInUserValue = {
        label: `${userInfo.name ?? userInfo.email} ${userInfo.surname ?? ""}`,
        value: userInfo._id,
      };

      setassignedUserValue(loggedInUserValue);
      setassignedUserId(userInfo._id);
      getLastSavedTaskDetails();
    }
  }, []);

  //previous task
  useEffect(() => {
    if (previousTaskInput.length > 0) {
      getAllPreviousTask();
    }
  }, [previousTaskInput]);

  useEffect(() => {
    if (projectInput.length > 0) {
      getProjectList();
    }
  }, [projectInput]);

  useEffect(() => {
    if (sectionInput.length > 0 && taskProjectId) {
      getSectionList();
    }
  }, [sectionInput, taskProjectId]);

  useEffect(() => {
    if (leadInput.length > 0) {
      getLeadList();
    }
  }, [leadInput]);

  useEffect(() => {
    if (contactInput.length > 0) {
      getContactList();
    }
  }, [contactInput]);

  useEffect(() => {
    if (assignedUserInput.length > 0) {
      getAssignedUserList();
    }
  }, [assignedUserInput]);

  useEffect(() => {
    if (followersInput.length > 0) {
      getFollowersList();
    }
  }, [followersInput]);

  //assign default member as logged in user.It is use for options in save task tab
  useEffect(() => {
    defaultValueAssignHandler();
  }, [moduleName, projectValue, moduleSlug, selectedSectionValue]);

  const customStatusStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.status ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.status ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  const customPriorityStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.priority ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.priority ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  return (
    <div>
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="p-4">
        {/* <!-- ========== Start title Section ========== --> */}
        <div className="mb-4">
          <h2 className="mb-0">
            {taskCustomId ? (
              <span className="badge bg-dark me-2">{taskCustomId}</span>
            ) : null}
            {title}
          </h2>
        </div>
        {/* <!-- ========== End title Section ========== --> */}

        {/* <!-- ========== Start title Section ========== --> */}
        <div className="form-group mb-4">
          <label htmlFor="taskName" className="d-block fs-sm fw-semibold mb-2">
            {t("Task Name")}
          </label>
          <input
            type="text"
            id="taskName"
            className={`form-control fs-sm shadow-none ${
              errors.name ? "is-invalid" : "border border-gray-300"
            }`}
            placeholder={t("e.g., Design new homepage mockup")}
            value={title}
            onChange={(e) => {
              settitle(e.target.value);
              if (errors.name) {
                setErrors((prev) => ({ ...prev, name: "" }));
              }
              seterrorMessage("");
            }}
          />
          {errors.name && (
            <div className="invalid-feedback d-block">{errors.name}</div>
          )}
        </div>
        {/* <!-- ========== End title Section ========== --> */}

        {/* <!-- ========== Start module select Section ========== --> */}
        <div className="form-group mb-4">
          <label htmlFor="status" className="d-block fs-sm fw-semibold mb-2">
            {t("Select Module For Task")}
          </label>
          <Select
            isClearable
            placeholder={t("Choose a module (e.g., Project, Lead)")}
            styles={reactSelectStyle("3px", "6px", true, false)}
            options={TaskModules}
            value={moduleValue}
            onChange={(val) => {
              moduleSelectionHandler(val);
            }}
          />
        </div>
        {/* <!-- ========== End module select Section ========== --> */}

        {/* <!-- ========== Start project and Section ========== --> */}
        {moduleSlug === "MOD_PROJECT" || taskProjectId ? (
          <div className="form-group mb-4">
            <div className="row">
              {/* <!-- ========== Start project Section ========== --> */}
              {taskProjectId || moduleSlug === "MOD_PROJECT" ? (
                <div className="col-md-6 mb-4 mb-md-0">
                  <label
                    htmlFor="status"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Select Project")}
                  </label>
                  <Select
                    isClearable
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    placeholder={t("Search by project name...")}
                    options={projectListOptions}
                    value={selectedProjectValue}
                    onChange={(val) => {
                      projectSelectionHandler(val);
                    }}
                    onInputChange={(val) => {
                      setprojectInput(val);
                    }}
                  />
                </div>
              ) : null}
              {/* <!-- ========== End project Section ========== --> */}

              {/* <!-- ========== Start Section ========== --> */}
              {selectedSectionId ||
              moduleSlug === "MOD_PROJECT" ||
              taskProjectId ? (
                <div className="col-md-6">
                  <label
                    htmlFor="section"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Section")}
                  </label>
                  <Select
                    isClearable
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    placeholder={t("Search by section name...")}
                    options={sectionListOptions}
                    value={sectionValue}
                    onChange={(val) => {
                      sectionSelectionHandler(val);
                      seterrorMessage("");
                    }}
                    onInputChange={(val) => {
                      setsectionInput(val);
                    }}
                  />
                </div>
              ) : null}
              {/* <!-- ========== End Section ========== --> */}
            </div>
          </div>
        ) : null}
        {/* <!-- ========== End project and Section ========== --> */}

        {/* <!-- ========== Start lead Section ========== --> */}
        {moduleSlug === "MOD_LEAD" || taskLeadId ? (
          <div className="form-group mb-4">
            <label htmlFor="status" className="d-block fs-sm fw-semibold mb-2">
              {t("Select Lead")}
            </label>
            <Select
              isClearable
              styles={reactSelectStyle("3px", "6px", true, false)}
              placeholder={t("Search by lead name or email...")}
              options={leadListOptions}
              value={selectedLeadValue}
              onChange={(val) => {
                leadSelectionHandler(val);
              }}
              onInputChange={(val) => {
                setleadInput(val);
              }}
            />
          </div>
        ) : null}
        {/* <!-- ========== End lead Section ========== --> */}

        {/* <!-- ========== Start contact Section ========== --> */}
        {moduleSlug === "MOD_CONTACT" || taskContactId ? (
          <div className="form-group mb-4">
            <div className="form-group mb-4">
              <label
                htmlFor="status"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Select Contact")}
              </label>
              <Select
                isClearable
                styles={reactSelectStyle("3px", "6px", true, false)}
                placeholder={t("Search by contact name or email...")}
                options={contactOptions}
                value={selectedContactValue}
                onChange={(val) => {
                  contactSelectionHandler(val);
                }}
                onInputChange={(val) => {
                  setcontactInput(val);
                }}
              />
            </div>
          </div>
        ) : null}
        {/* <!-- ========== End contact Section ========== --> */}

        {/* <!-- ========== Start assigned user and status Section ========== --> */}
        <div className="form-group mb-4">
          <div className="row">
            <div className="col-md-3">
              <label
                htmlFor="status"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Is Milestone")}
              </label>
              <input
                className="large-checkbox"
                type="checkbox"
                checked={isMilestone}
                onChange={(e) => setIsMilestone(e.target.checked)}
              />
            </div>

            <div className="col-md-6">
              <label
                htmlFor="assignTo"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Assigned to")}
              </label>
              <Select
                isClearable
                styles={reactSelectStyle("3px", "6px", true, false)}
                placeholder={
                  moduleName == "lead" || moduleName == "contact"
                    ? t("Select Member")
                    : t("Type member name or email")
                }
                options={assignedUserOptions}
                value={assignedUserValue}
                onChange={(val) => {
                  assignedUserSelectionHandler(val);
                  seterrorMessage("");
                }}
                onInputChange={(val) => {
                  assignedUserInputHandler(val);
                }}
              />
            </div>
            <div className="col-md-3">
              <label
                htmlFor="status"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Complete Status")}
              </label>
              <Select
                placeholder={t("Select task status")}
                styles={customStatusStyles}
                options={TaskStatusOptions}
                value={taskStatusValue}
                onChange={(val) => {
                  statusSelectionHandler(val);
                  if (errors.status) {
                    setErrors((prev) => ({ ...prev, status: "" }));
                  }
                  seterrorMessage("");
                }}
              />
              {errors.status && (
                <div className="invalid-feedback d-block">{errors.status}</div>
              )}
            </div>
          </div>
        </div>
        {/* <!-- ========== End assigned user and status Section ========== --> */}

        {/* <!-- ========== Start followers Section ========== --> */}
        <div className="form-group mb-4">
          <label htmlFor="assignTo" className="d-block fs-sm fw-semibold mb-2">
            {t("Followers")}
          </label>
          <Select
            isMulti
            styles={reactSelectStyle("3px", "6px", true, false)}
            placeholder={
              moduleName == "lead" || moduleName == "contact"
                ? t("Select Member")
                : t("Type member name or email")
            }
            options={followersOptions}
            value={followrsValue}
            onChange={(val) => {
              followersSelectionHandler(val);
              seterrorMessage("");
            }}
            onInputChange={(val) => {
              followersInputHandler(val);
            }}
          />
        </div>
        {/* <!-- ========== End followers Section ========== --> */}

        {/* <!-- ========== Start details Section ========== --> */}
        <div className="form-group mb-4">
          <label htmlFor="details" className="d-block fs-sm fw-semibold mb-2">
            {t("Details")}
          </label>

          <JoditEditor
            ref={editor}
            value={details}
            config={editorConfig}
            tabIndex={1}
            onBlur={(newContent) => {
              // console.log("New content in on blur----->", newContent);
              setdetails(newContent);
            }}
            onChange={(newContent, event) => {
              // setdetails(newContent);
            }}
          />
        </div>
        {/* <!-- ========== End details Section ========== --> */}

        {/* hours and price */}
        <div className="form-group mb-4">
          <div className="row">
            <div className="col-md-6 mb-4 mb-md-0">
              <label htmlFor="time" className="d-block fs-sm fw-semibold mb-2">
                {t("Time (Hours)")}
              </label>
              <input
                type="number"
                id="time"
                min={1}
                className={`form-control fs-sm shadow-none ${
                  errors.hours ? "is-invalid" : "border border-gray-300"
                }`}
                placeholder={t("e.g., 8")}
                value={hours}
                onChange={(e) => {
                  sethours(e.target.value);
                  if (errors.hours) {
                    setErrors((prev) => ({ ...prev, hours: "" }));
                  }
                  seterrorMessage("");
                }}
              />
              {errors.hours && (
                <div className="invalid-feedback d-block">{errors.hours}</div>
              )}
            </div>
            <div className="col-md-6">
              <label htmlFor="price" className="d-block fs-sm fw-semibold mb-2">
                {t("Price")}
              </label>
              <input
                type="number"
                min={0}
                id="price"
                className="form-control fs-sm shadow-none border border-gray-300"
                placeholder={t("Budget")}
                value={price}
                onChange={(e) => {
                  setPrice(e.target.value);
                }}
              />
            </div>
          </div>
        </div>

        {/* previoues task and priority */}
        <div className="form-group mb-4">
          <div className="row">
            <div className="col-md-6 mb-4 mb-md-0">
              <label
                htmlFor="status"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Previous task to complete (If Any)")}
              </label>
              <Select
                isClearable
                styles={reactSelectStyle("3px", "6px", true, false)}
                placeholder={t("Search for a preceding task...")}
                options={previousTaskIdaskListOptions}
                value={prevTaskValue}
                onChange={(val) => {
                  previousTaskSelectionHandler(val);
                }}
                onInputChange={(val) => {
                  setPreviousTaskInput(val);
                }}
              />
            </div>

            <div className="col-md-6">
              <label
                htmlFor="priority"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Priority")}
              </label>
              <Select
                styles={customPriorityStyles}
                placeholder={t("Select a priority level")}
                options={TaskPriority}
                value={priorityValue}
                onChange={(val) => {
                  prioritySelectionHandler(val);
                  if (errors.priority) {
                    setErrors((prev) => ({ ...prev, priority: "" }));
                  }
                  seterrorMessage("");
                }}
              />
              {errors.priority && (
                <div className="invalid-feedback d-block">
                  {errors.priority}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* <!-- ========== Start deadline and rank Section ========== --> */}
        <div className="form-group mb-4">
          <div className="row">
            <div className="col-md-6 mb-4 mb-md-0">
              <label
                htmlFor="deadline"
                className="d-block fs-sm fw-semibold mb-2"
              >
                {t("Deadline")}
              </label>
              <div className="field-container d-flex flex-column flex-lg-row gap-3 align-items-lg-center rounded-10">
                <input
                  type="date"
                  id="startdate"
                  className={`form-control fs-sm shadow-none ${
                    errors.startDate ? "is-invalid" : "border border-gray-300"
                  }`}
                  value={startDate}
                  onChange={(e) => {
                    setstartDate(e.target.value);
                    if (errors.startDate) {
                      setErrors((prev) => ({ ...prev, startDate: "" }));
                    }
                    if (errors.dateRange) {
                      setErrors((prev) => ({ ...prev, dateRange: "" }));
                    }
                    seterrorMessage("");
                  }}
                />
                <input
                  type="date"
                  id="enddate"
                  className={`form-control fs-sm shadow-none ${
                    errors.endDate ? "is-invalid" : "border border-gray-300"
                  }`}
                  value={endDate}
                  onChange={(e) => {
                    setendDate(e.target.value);
                    if (errors.endDate) {
                      setErrors((prev) => ({ ...prev, endDate: "" }));
                    }
                    if (errors.dateRange) {
                      setErrors((prev) => ({ ...prev, dateRange: "" }));
                    }
                    seterrorMessage("");
                  }}
                />
              </div>{" "}
              <div className="d-flex gap-2">
                {errors.startDate && (
                  <div className="invalid-feedback d-block">
                    {errors.startDate}
                  </div>
                )}
                {errors.endDate && (
                  <div className="invalid-feedback d-block">
                    {errors.endDate}
                  </div>
                )}
                {errors.dateRange && (
                  <div className="invalid-feedback d-block">
                    {errors.dateRange}
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <label htmlFor="price" className="d-block fs-sm fw-semibold mb-2">
                {t("Rank")}
              </label>
              <input
                type="number"
                min={1}
                id="price"
                className="form-control fs-sm shadow-none border border-gray-300"
                placeholder={t("Rank")}
                value={rank}
                onChange={(e) => {
                  setRank(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        {/* <!-- ========== End deadline and rank Section ========== --> */}

        {/* ------ upload documnet section start ------- */}
        <div className="form-group mb-3 mb-sm-4">
          <label htmlFor="documents" className="d-block fs-sm fw-semibold mb-2">
            {t("Upload Documents")}
          </label>
          <FileUploadField
            label={t("Upload Documents")}
            accept="doc mp4 pdf"
            onUpload={docFileUploadHandler}
            files={uploadedDocFiles}
            onRemove={closeDocFileHandler}
            loading={docFileUploading}
            multiple
            fileType="document"
          />
        </div>
        {/* ------ upload documnet section end ------- */}
        </div>
        {/* <!-- ========== Start button Section ========== --> */}
        <div className="action d-flex align-items-center gap-3 p-4 border-top bg-white" style={{ position: "sticky", bottom: 0 }}>
          <button
            type="button"
            className="btn btn-primary"
            onClick={saveTaskHandler}
            style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
            disabled={isSaving ? true : false}
          >
            {t("Save Task")}
            {isSaving && (
              <div
                className="mx-2 spinner-border spinner-border-sm"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
          </button>
          {errorMessage == "" ? null : (
            <div className="error-message">
              <p className="d-flex align-items-center gap-1 text-danger">
                <span>{errorMessage} !</span>
              </p>
            </div>
          )}
        </div>
        {/* <!-- ========== End button Section ========== --> */}
      </form>
    </div>
  );
};

export default SaveTaskTab;
